/*
 * Copyright (c) 2022 Certusoft, Inc. All Rights Reserved.
 *
 * This SOURCE CODE FILE, which has been provided by Certusoft as part
 * of a Certusoft product for use ONLY by licensed users of the product,
 * includes CONFIDENTIAL and PROPRIETARY information of Certusoft.
 *
 * USE OF THIS SOFTWARE IS GOVERNED BY THE TERMS AND CONDITIONS
 * OF THE LICENSE STATEMENT AND LIMITED WARRANTY FURNISHED WITH
 * THE PRODUCT.
 */

import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../services/auth/auth.service'

@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.less'],
})
export class NavComponent implements OnInit {
    constructor(private authService: AuthService) {}

    ngOnInit(): void {}

    authenticated(): boolean {
        return this.authService.authenticated()
    }
}
